<template>
  <qx-card title="客户订单列表">
    <LogRightDialog ref="logRightDialog" busiCode="100023" />
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click="() => dispatch()">
          <i class="iconfont">&#xe607;</i>调度</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions>
        <ImportBtn
          title="客户订单导入"
          bizCodes="imp1000201"
          fileUrl="客户订单导入模板.xlsx"
        />
      </qx-permpisions>
      <!-- <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="cityCustomerOrderBO.ajax?cmd=queryPage"
          :params="fullSearchData"
          bizName="客户订单导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions> -->
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'sourceAddressName'">
                  <span
                    class="primary cur"
                    @click="
                      toAddressDetail(
                        scope.row.sourceAddressId,
                        scope.row.sourceAddressName
                      )
                    "
                    >{{ scope.row[scope.column.property] }}</span
                  >
                </section>
                <section v-else-if="scope.column.property === 'desAddressName'">
                  <span
                    class="primary cur"
                    @click="
                      toAddressDetail(
                        scope.row.desAddressId,
                        scope.row.desAddressName
                      )
                    "
                    >{{ scope.row[scope.column.property] }}</span
                  >
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '取消',
                    event: () => toCancel(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toDetail(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.customerId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
// import ExportBtn from 'components/exportBtn';
import ImportBtn from 'components/importBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  cityCustomerOrderQueryPage,
  cityCustomerOrderDeleteByCcoId,
} from 'api/distribution';
import {
  queryAddressInfo,
} from 'api';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    // ExportBtn,
    ImportBtn,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      addressList: [],
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'customerName', label: '客户', fixed: true },
          { prop: 'orderTimeStr', label: '下单时间' },
          { prop: 'sourceAddressName', label: '出发地名称' },
          { prop: 'desCityName', label: '目的城市' },
          { prop: 'consignee', label: '收货方' },
          { prop: 'desAddressName', label: '目的地名称' },
          { prop: 'quantityShipped', label: '数量' },
          { prop: 'quantityShippedUnitName', label: '单位' },
          { prop: 'deliveryTime', label: '提货时间' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'driverName', label: '司机姓名' },
          { prop: 'requiredTime', label: '时效（小时）' },
          { prop: 'orderStateName', label: '状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: cityCustomerOrderQueryPage,
    async toCancel (item) {
      const confirmRes = await this.$confirm('是否确认取消该订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await cityCustomerOrderDeleteByCcoId({
          ccoId: item.ccoId,
        });
        if (!res.failed) {
          this.$message.success('操作成功');
          this.getData();
        }
      }
    },
    toEdit (item) {
      this.jump({
        label: item ? '修改客户订单' : '新增客户订单',
        url: `/manage/distribution/customerOrder/edit?id=${item ? item.ccoId : ''}`,
        full: true,
      });
    },
    toAddressDetail (addressId, addressName) {
      this.jump({
        label: `地址档案详情-${addressName}`,
        url: `/manage/distribution/addressArchives/detail?id=${addressId}`,
        full: true,
      });
    },
    toDetail (item) {
      this.jump({
        label: `客户订单详情-${item.customerName}`,
        url: `/manage/distribution/customerOrder/detail?id=${item ? item.ccoId : ''}`,
        full: true,
      });
    },
    dispatch () {
      this.jump({
        label: '调度',
        url: '/manage/distribution/customerOrder/dispatch/edit',
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
  },
  async created () {
    this.addressList = await queryAddressInfo();
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
